/** /my-coaching/business/nova/assets — My assets and each asset's page. */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/my-coaching/business/nova/assets")(
  {
    staticData: { title: "My assets" },
    component: () => <Outlet />,
  },
);
